<template>
  <div>
    <a-card :bordered="false" :bodyStyle="tstyle">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">

            <a-col :md="6" :sm="24">
              <a-form-item label="日期">
                <a-range-picker @change="handlDate"/>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
                <a-button
                  style="margin-left: 8px"
                  @click="() => queryParam = {  }">重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-card>
    <a-card :bordered="false">
      <s-table
        ref="table"
        :columns="columns"
        :pageSize="1000"
        :rowKey="(record) => record.nurseItemId"
        :hideOnSinglePage="true"
        :data="loadData">
      </s-table>
    </a-card>
  </div>
</template>
<script>
import { STable, XDown } from '@/components'
import moment from 'moment'
import {
  getNurseStatisticsSummary
} from '@/api/modular/interhospital/nursing/nursingMange'

export default {
  components: {
    STable,
    XDown
  },
  data() {
    return {
      checked: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      labelCol_two: {
        xs: { span: 24 },
        sm: { span: 2 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 19 }
      },
      form: {},
      visible: false,
      confirmLoading: false,
      Loading: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        // pageNo: 1,
        // pageSize: 10,
      },
      // 表头
      columns: [
        {
          title: '护理项目',
          align: 'center',
          dataIndex: 'nurseItemName',
        },
        {
          title: '预约人次',
          align: 'center',
          dataIndex: 'aptmentTimes'
        },
        {
          title: '完成服务人次',
          align: 'center',
          dataIndex: 'aptmentCompleteTimes',
        },
        {
          title: '预约评估人次',
          align: 'center',
          dataIndex: 'assmentTimes',
        },
        {
          title: '完成评估人次',
          align: 'center',
          dataIndex: 'assmentCompleteTimes',
        },
      ],
      tstyle: { 'padding-bottom': '0px', 'margin-bottom': '10px' },
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return new Promise(async (resolve, reject) => {
          const res = await getNurseStatisticsSummary(this.switchingDate())
          resolve(res.data)
        })
      },
      options: {
        showPagination: {
          disabled: true,
        }
      },
      recordList: {},
    }
  },
  created() {
    // if (this.hasPerm('nursing:edit') || this.hasPerm('nursing:delete')) {
    // this.columns.push({
    //   title: '操作',
    //   width: '150px',
    //   dataIndex: 'action',
    //   scopedSlots: { customRender: 'action' }
    // })
    // }
  },
  methods: {
    moment,
    /**
     * 查询参数组装
     */
    switchingDate() {
      const queryParamverifytime = this.queryParam.verifytimeDate
      if (queryParamverifytime != null) {
        this.queryParam.verifytime = moment(queryParamverifytime).format('YYYY-MM-DD')
        if (queryParamverifytime.length < 1) {
          delete this.queryParam.verifytime
        }
      }
      const obj = JSON.parse(JSON.stringify(this.queryParam))
      return obj
    },

    // 提交时间
    handlDate(date, dateString) {
      this.queryParam.searchBeginTime = dateString[0]
      this.queryParam.searchEndTime = dateString[1]
    },

    handleOk() {
      this.$refs.table.refresh()
    },

    // 日期框
    changeDate(data, dateString) {
      console.log(dateString)
      this.form.date = dateString
    },
  }
}
</script>
<style lang="less">
.table-operator {
  margin-bottom: 18px;
}

button {
  margin-right: 8px;
}
</style>
